
















import Vue from "vue";
export default Vue.extend({
  props: {
    align: {
      type: String,
      default: "right",
    },
    header: {
      type: String,
      default: "Placeholder Header",
    },
    body: {
      type: String,
      default: `At DeltaHacks, we believe change comes from dreaming big. Each year we enable over 800 students from across Canada, working hard over 36 hours, to bring their big ideas to life. Our team works diligently year round to provide a welcoming atmosphere to all of our participants. DeltaHacks gives you the platform to make an idea a reality, whether it be with a team, or on your own. Unleash your creativity and make something great, we'll handle the rest! Make big ideas a reality at DeltaHacks VI!`,
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: "DeltaHacks VII Button",
    },
    buttonLink: String,
  },
});
